import { createContext } from 'react';

export interface SessionDetailsContextType {
  isLoading: boolean;
  isParentView?: boolean;
}

export const SessionDetailsContext = createContext<SessionDetailsContextType>({
  isLoading: true,
  isParentView: false,
});
